module.exports = __webpack_public_path__ + "img/info-icon@3x.18fc3cce.png";